module.exports = __webpack_public_path__ + "img/diff-2.a7012c14.png";